module.exports = __webpack_public_path__ + "static/media/IMG_1246.de2fe82d.jpg";